import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Input from '../form/inputs/Input'
import Heading from './../heading/Heading'
import Button from '../buttons/Button';
import leasingItemsData from './../../static-data/leasing-items'
import SelectColumns from './../form/selects/SelectsColumns'
import SelectsWritable from './../form/selects/SelectsWritable';
import { convertPrice } from './../../services/convertPrice';
import { getAmortization } from './../../services/getAmortization';
import ModalMessage from './../modal-message/ModalMessage'
import info from './../../images/i-ico.svg'
import getDataFromUrl from './../../services/getDataFromUrl';
import { getApiLink } from './../../services/getApiLink'
import Checkbox from '../form/checkbox/Checkbox'
import placeholder from '../../images/placeholder-img.png'
import placeholderCoffe from '../../images/express-img.png'
import deleteItem from '../../images/close-white.svg'
import formatPrice from '../../services/formatPrice';
import checkNaN from '../../services/checkNaN';

const LeasingItems = (props) => {
    let [ load, setLoad ] = useState(false);
    let [ lockInputs, setLockInputs ] = useState(false);
    let [ dataFromFile, setDataFromFile ] = useState(false);
    let [ updateArray, setUpdateArray ] = useState(0);
    let [ forceValidateFromName, setForceValidateFromName ] = useState(false);
    let [ activeModal, setActiveModal ] = useState(false);
    let [ copyCategories, setCopyCategories ] = useState(false);
    let [ errorCheckboxCopy, setErrorCheckboxCopy ] = useState(false);
    let [ disableForm, setDisableForm ] = useState(false);
    let [ enableCategory, setEnableCategory ] = useState(false);
    let [ enableInputsByProvider, setEnableInputsByProvider ] = useState(false);
    let [ disabledLeasingItemsStatus, setDisabledLeasingItemsStatus ] = useState(false);

    const dispatch = useDispatch()
    let productPrice = useSelector(state => state.productPrice);
    let products     = useSelector(state => state.products);
    let isShop     = useSelector(state => state.isShop);
    let errorFvUpload     = useSelector(state => state.errorFvUpload);
    let disableUpload     = useSelector(state => state.disableUpload);
    let allowForm           = useSelector(state => state.allowForm);
    // let providerName     = useSelector(state => state.providerName);
    let providerName = true;

    let disabledLeasingItems = window.AppConfig ? window.AppConfig.disabledLeasingItems : [''];
    // let disabledLeasingItems = window.AppConfig ? window.AppConfig.disabledLeasingItems : ['ekspres','chlodnia','czytnik','dron','drukarka','hala','hulajnoga','monitoring','lampy','kamera','klima','konsola','kopiarka','laptop','myjka','grawer','pakowarka','ciecie','meble','monitor','kosmetyczka','niszczarka','solary','rzutnik','komorka','smartwatch','foto','gastro','it','medyczny','naglosnienie','telekomunikacja','tablet','fitness','akcesoriait','warsztat','biuro','tv','rower','poligrafia','Wózek','jubiler'];
    let disableProducts =  window.AppConfig ? window.AppConfig.disableProducts : false;
    // 'ekspres','chlodnia','czytnik','dron','drukarka','hala','hulajnoga','monitoring','lampy','kamera','klima','konsola','kopiarka','laptop','myjka','grawer','pakowarka','ciecie','meble','monitor','kosmetyczka','niszczarka','solary','rzutnik','komorka','smartwatch','foto','gastro','it','medyczny','naglosnienie','telekomunikacja','tablet','fitness','akcesoriait','warsztat','biuro','tv','rower','poligrafia','Wózek','jubiler'
 
    // if document have data
    useEffect(() => {
        if ( props.data && props.data.length > 0) 
        { 
            dispatch( {type: 'SET_PRODUCTS', value:  props.data } )
            setDisableForm(false);
            setUpdateArray( ++updateArray );
        }
    }, [props.data]);

    useEffect(() => {
        if ( load && errorFvUpload ) 
        { 
            setDisableForm(false);
            setUpdateArray( ++updateArray );
        }
    }, [ errorFvUpload ]);

    useEffect(() => {
        if ( load && isShop) 
        { 
            setDisableForm(false);
        }
    }, [isShop]);

    useEffect(() => {
        if(providerName && !isShop && load) {
            if(disableUpload) {
                setEnableInputsByProvider(false);
            }else{
                setEnableInputsByProvider(true);
            }
        }
    }, [providerName, disableUpload, isShop, load])



    useEffect(() => {
        if(!load) {
            checkToken();
            if ( products.length > 0 && products[0].type.length > 0 ) {
                setDisableForm(false);
                setUpdateArray(++updateArray);
            } else {
                if ( window.location.pathname.indexOf('kalkulacja') === -1 ) {
                    setDisableForm(true)
                }
                setUpdateArray(++updateArray);
            }
            setLoad(true);
            
        } 
    }, [load])

    // useEffect(() => {
    //     if(isShop) {
    //        let disable =  window.AppConfig ? window.AppConfig.disableProducts : false;
    //        setLockInputs(true)
    //     }
    // }, [isShop])

    useEffect(() => {
        if(copyCategories) {
            copyCategoryToProducts();
        }
    }, [copyCategories])

    let copyCategoryToProducts = async() => {
        let getAmortization = products[0].amortization;
        let getType = products[0].type;
        let copyProducts = products;

        await products.map( (el, i) => {
            copyProducts[i].amortization = getAmortization;
            copyProducts[i].type = getType;
        } )

        await dispatch( {type: 'SET_PRODUCTS', value:  copyProducts } )
        await setUpdateArray(++updateArray);
    }

    let checkToken = () => {
        console.log('check token');
        let token = getDataFromUrl("token");
        let productName = getDataFromUrl("p");
        let price = getDataFromUrl("c");
        let category = getDataFromUrl("k");
        let paramsUrl = getDataFromUrl("paramsUrl");

        if(productName && price && !category) {
            setEnableCategory(true);
        }

        if(productName && price) {
            // dispatch( {type: 'DISABLE_UPLOAD', value:  true } )
            if(paramsUrl) {
                if(paramsUrl == 1) {
                    dispatch( {type: 'DISABLE_UPLOAD', value:  true } );
                }else{
                    dispatch( {type: 'DISABLE_UPLOAD', value:  false } );
                }
            }else{
                dispatch( {type: 'DISABLE_UPLOAD', value:  true } );
            }
        }

        let newProduct = products

        if(token && token.length > 0) {
            console.log(token)
            setDisableForm(false);
            let req = new XMLHttpRequest();
            req.open('POST', `${ getApiLink() }/getShopProduct.php`);
            req.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"); 
            req.send(`token=${token}`);
            setLockInputs(true);
            
            req.addEventListener("readystatechange", async function () {
                if (this.readyState === 4) {
                    let resp = JSON.parse(req.response);
                    if ( resp.status === 'done') {
                        let quant = "1";
                        // http://localhost:3000/?token=o70c28l7gcd6xihnb16ary&k=drukarka
                        newProduct[0].name = resp.productName
                        newProduct[0].price = convertPrice(resp.productPrice)
                        newProduct[0].quantity = quant.replace(' ', '')
                        if (category && category.length > 0 ) {
                            newProduct[0].amortization = getAmortization(category);
                            newProduct[0].type = category;
                        }
                        dispatch( {type: 'SET_PRODUCTS', value:  newProduct } )
                        props.updateProducts();
                        props.recalculateRates();
                    }
                }
            });
        } else if( productName && productName.length > 0) {
            setTimeout(() => {
                
                let quant = "1";
                newProduct[0].name = productName
                newProduct[0].price = convertPrice(price)
                newProduct[0].quantity = quant.replace(' ', '')
                if (category && category.length > 0 ) {
                    newProduct[0].amortization = getAmortization(category);
                    newProduct[0].type = category;
                }
                dispatch( {type: 'SET_PRODUCTS', value:  newProduct } )
                setLockInputs(true)
                setUpdateArray(++updateArray);
                props.updateProducts();
                props.recalculateRates();

            }, 500);
        }
    }

    let filterLeasingItems = () => {
        let leasingItemsFiltered = [];
        if ( disabledLeasingItems.length > 0 ) {
            leasingItemsData.map( el => {
                if ( disabledLeasingItems.indexOf( el.skrot ) === -1 ) {
                    leasingItemsFiltered.push( el )
                } 
            })
            return leasingItemsFiltered;
        } else {
            return leasingItemsData;
        }
    }

    let updateValue =  async( val, index, property ) => {
        let copyArray = products;
        let quant = await copyArray[index]['quantity'].replace(' ', '')
        let amortization = await copyArray[index]['amortization']

        if ( property == 'quantity' ) {
            quant = val.replace(' ', '')
        }
        if ( property == 'type' ) {
            amortization = getAmortization(val);
            copyArray[index]['amortization'] = amortization;
            props.setUpdateType();
        }
        
        copyArray[index][property] = val;
        copyArray[index]['equal'] =  await calculateFinalPrice(quant, copyArray[index]['price']);
        
        let newProduct = copyArray[index];
        if ( newProduct.amortization > 0 && 
             newProduct.equal.length > 0 &&
             newProduct.name.length > 0 &&
             newProduct.price.length > 0 &&
             newProduct.quantity.length > 0 &&
             newProduct.type.length > 0 
           ) {
               
            copyArray[index]['added'] = true;
        }
        await dispatch( {type: 'SET_PRODUCTS', value:  copyArray } )
        await setUpdateArray(++updateArray);

        if (property == 'type') {
            await props.recalculateRates();
        }

        if ( property == 'type' &&  
                copyCategories && 
                val !== products[0].type && 
                products[ products.length - 1].type.length > 0) {

                    if ( val === '' && products[ products.length - 1].type.length > 0 ) {
                        return false
                    } else {
                        await setCopyCategories(false);
                    }
                    
        }

    }
    let calculateFinalPrice = ( quantity, price ) => {
        let quant = quantity.replace(' ', '')
        quant = parseFloat(quantity);
        let tempPrice = price.replace(',', '.')
        tempPrice = tempPrice.replace(' ', '');
        tempPrice = tempPrice.replace(' ', '');

        let prc = parseFloat(tempPrice);

        if ( quant > 0 && prc > 0 ) {
            let final = (quant * prc).toFixed(2)
            return convertPrice(final);
        } else {
            return '';
        }
    }
    let fvError = async() => {
        await dispatch( {type: 'ERROR_ADD_PRODUCT_FV_CHANGE', value:  true } )
        let elements = document.querySelectorAll('.error');
        if( elements.length > 0 ) {
            let topElement = elements[0].getBoundingClientRect().top;
            let windowScroll = window.scrollY;
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: windowScroll + topElement - 140
              });
        }
    }
    let addItemToArray = async() => {
        // if ( disableForm ) {
        //     await fvError();
        //     return false;
        // } else {
        //    await dispatch( {type: 'ERROR_ADD_PRODUCT_FV_CHANGE', value:  false } )
        // }
        await dispatch( {type: 'ERROR_ADD_PRODUCT_FV_CHANGE', value:  false } )
        await props.setForceValidateItems(true);
        await wait(10);
        let errors = await checkErrors();
        if ( !errors ) {
            await props.setForceValidateItems(false);
            await updateValue(true, products.length - 1, 'added')
            let el = {
                type: copyCategories ? products[0].type : '',
                name: '',
                price: '',
                quantity: '',
                equal: '',
                amortization: '',
                added: false
            };
            let copy = [ ...products, el ];
            await dispatch( {type: 'SET_PRODUCTS', value:  copy } )
            await setUpdateArray(++updateArray);
        } 
    }
    let removeFromArray = async ( i ) => {
        let copyArray = products;
        await copyArray.splice(i, 1);
        await dispatch( {type: 'SET_PRODUCTS', value:  copyArray } )
        await setUpdateArray(++updateArray);


    }
    let getSummaryPrice = () => {
        let price = 0;
        for (let i = 0; i < products.length; i++) {
            const element = products[i];
            let num = parseFloat(element.equal);
            if ( isNaN( num ) ) {
                break;
            } else {
                let el = element.equal.toString();
                let tempSummary = el.replace(',', '.');
                tempSummary = tempSummary.replace(' ', '');
                tempSummary = tempSummary.replace(' ', '');
                tempSummary = tempSummary.replace(' ', '');

                price = parseFloat(price) + parseFloat(tempSummary);
            }
        }
        return convertPrice(price.toFixed(2));
    }
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }
    let checkErrors = () => {
        let result;
        let elements = document.querySelectorAll('.leasing-items .inputs .error');
        if( elements.length > 0 ) {
            result = true;
        } else {
            result = false;
        }
        return result;
        
    }

    useEffect(() => {
        const changePrice = async () => {
            let val = await getSummaryPrice();
            let tempSummary = val.replace(',', '.');
                tempSummary = tempSummary.replace(' ', '');
                tempSummary = tempSummary.replace(' ', '');
                tempSummary = tempSummary.replace(' ', '');
                tempSummary = parseFloat(tempSummary).toFixed(2)
                await dispatch( {type: 'PRODUCT_PRICE_CHANGE', value:  tempSummary } )
        }
        changePrice()
        props.updateProducts();
    }, [updateArray])

    let keyPressed = (e, i) => {
        if (e.key === "Enter") {
          removeFromArray(i)
        }
    }

    let checkSessionProductsLength = ( index ) => {
        let productLength = window.AppConfig && window.AppConfig.products ? window.AppConfig.products.length : 0;
        if ( productLength > 0 && index < productLength ) {
            return true
        } 
        if ( productLength === 0 && index === 0) {
            return true
        }
    }

    setTimeout(() => {
        if(!disabledLeasingItemsStatus) {
            setDisabledLeasingItemsStatus(true);
        }
    }, "1500");

    return (
        <div className={"leasing-items" + (isShop ? ' shop' : '')}>
            { !isShop && 
                <Heading  title={ errorFvUpload ? 
                    "błąd odczytu, uzupełnij poniższe pola ręcznie" :
                    "" }
                    class = { errorFvUpload ? 'error other-margins' : '' }
                    tip={ false }
                    small />

                    
            }
            { isShop &&
                <Heading title="Przedmiot"
                    tip={ false } 
                    medium={true} />
            }
                <div className="header">
                    { isShop &&
                        <p>Zdjęcie/symbol</p>
                    }
                    <p>Rodzaj produktu</p>
                    <p>Nazwa produktu</p>
                    <p>Cena netto</p>
                    <p>Ilość</p>
                    <p>Suma netto</p>
                    <p></p>
                </div>
                    <div className={ "inputs list "  }>
                        { updateArray >= 0 && products && products.map( ( item, index ) => (
                           <>
                           <div className={ "row" + (products.length > 1 && !props.disableSelect ? " small-margin": "")} key={ index } >
                                { isShop &&
                                    <div className="col">
                                        <div id={`product-${index}`} className="image">
                                            {/* <img src={ index === 0 && products.length > 1 ? placeholderCoffe : placeholder } alt=""/> */}
                                                <img src={ item.image } alt=""/>
                                        </div>
                                    </div>
                                }
                                
                                <div className="col">
                                    {/* <SelectColumns  */}
                                    <SelectsWritable
                                        id={`product-type-${index}`}
                                        data={ load && disabledLeasingItemsStatus && filterLeasingItems() } 
                                        showEmptyError={ ( props.data && props.data.length > 0 ? true : false )} 
                                        forceValidate={ props.forceValidate } 
                                        forceValidateItems={ props.forceValidateItems }
                                        forceValidateFromName={ forceValidateFromName }
                                        val={ item.type }
                                        setForceValidateFromName={ () => setForceValidateFromName(false) }
                                        placehold="Rodzaj produktu" 
                                        index={ index }
                                        checkFv={ () => fvError() }
                                        errorCheckboxCopy={ errorCheckboxCopy }
                                        copyCategories={ copyCategories }
                                        // disabled={ (props.disableSelect || disableForm) ? (enableCategory ? false : true) : false }
                                        disabled={ (props.disableSelect && !enableInputsByProvider || disableForm && !enableInputsByProvider) ? (enableCategory ? false : true) : false }
                                        setFunction={ (val) => updateValue(val, index, 'type') } />
                                </div>
                                <div className="col">
                                    <Input 
                                        id={`product-name-${index}`}
                                        name={"product-"+index}
                                        required={ true }
                                        setFunction={ val => { updateValue(val, index, 'name'); } }
                                        type="text"
                                        placehold={ "Nazwa produktu" }
                                        val={ item.name }
                                        size="full" 
                                        regExp={ /(?!^\d+$)^.+$/ }
                                        notSpecial={ isShop ? false : true }
                                        // notSpecial={false}
                                        minChar={ 3 } 
                                        forceValidate={ props.forceValidate }
                                        forceValidateItems={ props.forceValidateItems }
                                        setValidateSelectField={ true }
                                        cloud={ true }
                                        setForceValidateFromName={ () => setForceValidateFromName(true) } 
                                        // disabledForce={ disableForm }
                                        disabledForce={ enableInputsByProvider ? false : disableForm }
                                        disabled={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        activeInput={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        checkFv={ () => fvError() }  />
                                </div>
                                <div className="col">
                                    <Input 
                                        id={`product-price-netto-${index}`}
                                        name="price"
                                        required={ true }
                                        setFunction={ val => { updateValue(val, index, 'price') } }
                                        type="text"
                                        formatPrice={ true }
                                        placehold={ "Cena netto" }
                                        val={ item.price }
                                        size="full" 
                                        regExp={/^[0-9\,\.\s]+$/}
                                        allowChars={/^[0-9\,\.\s]+$/}
                                        minChar={ 1 } 
                                        forceValidate={ props.forceValidate } 
                                        forceValidateItems={ props.forceValidateItems } 
                                        // disabledForce={ disableForm }
                                        disabledForce={ enableInputsByProvider ? false : disableForm }
                                        checkFv={ () => fvError() } 
                                        disabled={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        activeInput={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } />
                                </div>
                                <div className="col">
                                    <Input 
                                        id={`product-quantity-${index}`}
                                        name="quantity"
                                        required={ true }
                                        setFunction={ val => { updateValue(val, index, 'quantity') } }
                                        type="text"
                                        placehold={ "Ilość" }
                                        val={ item.quantity }
                                        size="full"
                                        formatAmount={ true }
                                        regExp={/^[0-9]{0,5}[\s?]{0,1}[0-9]{0,5}$/}
                                        allowChars={/^[0-9]{0,5}$/}
                                        minChar={ 1 } 
                                        maxChar={ 3 }
                                        max={ 100 }
                                        forceValidate={ props.forceValidate }
                                        forceValidateItems={ props.forceValidateItems } 
                                        // disabledForce={ disableForm }
                                        disabledForce={ enableInputsByProvider ? false : disableForm }
                                        checkFv={ () => fvError() } 
                                        disabled={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        activeInput={ (disableProducts || lockInputs) && checkSessionProductsLength( index )  ? true : false }  />
                                </div>
                                <div className="col">
                                    <Input 
                                        id={`product-equal-${index}`}
                                        name="equal"
                                        required={ true }
                                        type="text"
                                        placehold='Suma netto'
                                        activeInput={ item.equal && item.equal.toString().length > 0 ? true : false } 
                                        size="full" 
                                        val={ item.equal }
                                        displayValue={ true }
                                        setFunction={ () => false }
                                        // disabledForce={ disableForm }
                                        disabledForce={ enableInputsByProvider ? false : disableForm }
                                        disabled={ true } />
                                </div>
                                <div className="col">
                                    { (products && products.length >= 2) && !disableProducts &&
                                        <div className="wrapper">
                                            <div className="btn-delete" role="button" tabindex="0" onClick={ () => removeFromArray( index ) } onKeyPress={ (e) => keyPressed(e, index)}>
                                                <span><img src={ deleteItem } alt=""/></span> <span>Usuń Przedmiot</span>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <>
                                { index === 0 && products.length > 1 && !props.disableSelect &&
                                    <div className="copy">
                                        <Checkbox  required={ false } 
                                            setFunction={ (val) => { 
                                                if ( val && products[0].type === '' ) {
                                                    setErrorCheckboxCopy(true)
                                                } else {
                                                    setErrorCheckboxCopy(false)
                                                    setCopyCategories(val) 
                                                }
                                            }
                                            }
                                            forceValidate={ props.forceValidate }
                                            val={ copyCategories }
                                            tip={ true }
                                            tipHeader="Kopiuj wybrany rodzaj przedmiotu"
                                            tipText="Zweryfikuj, czy wskazane rodzaje przedmiotów są adekwatne do każdego sprzętu. <br> Jeżeli dana pozycja wymaga zmiany, dokonaj jej manualnie wybierając z rozwijanej listy najbardziej adekwatną kategorię."
                                            button={ false }
                                            text="Powiel pierwszy rodzaj przedmiotu do wszystkich pozycji" />
                                    </div>
                                    
                                }
                            </>
                            </>
                        ))}

                    </div>
                    <div className={"summary-wrap " + ( products && products.length >= 2 ? 'active-delete' : '') + (isShop ? ' shop' : '')}>
                        { !isShop &&
                            <div className={"buttons " + ( productPrice >= 100000 ? 'bigPrice': '')}>
                                {!disableUpload && 
                                    <Button class="blue reverse" title="Dodaj Przedmiot" add={ true } setFunction={ () =>  addItemToArray() } />
                                }
                                
                                {/* { products && products.length >= 2 &&
                                    <Button class="blue reverse" title="Usuń Przedmiot" minus={ true } setFunction={ () => removeLastFromArray() } />
                                } */}
                            </div>
                        }
                        
                        <div className={"summary " + ( productPrice < 1500 ? 'error-item' : '' ) }>
                            Razem netto: <span>{ convertPrice(productPrice)} zł</span>
                            <img src={ info } alt="informacja" onClick={ () => setActiveModal( true )} />
                            {/* { props.clickedButton > 0 && productPrice < 1500 && isShop &&
                                <p>
                                    Za mała wartość. Min. 1500 zł
                                </p>
                            }
                            { (productPrice < 1500 && productPrice > 0 || props.clickedButton > 0 && productPrice < 1500) && !isShop &&
                                <p>
                                    Za mała wartość. Min. 1500 zł
                                </p>
                            } */}
                            {isShop &&
                                <>
                                    {props.clickedButton > 0 && productPrice < 1500 &&
                                        <p>
                                            Za mała wartość.
                                        </p>
                                    }
                                    {/* {productPrice >= 1500 && productPrice < 4500 && allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                                        <p>
                                            Za mała wartość. Min. 4,5tys. zł
                                        </p>
                                    } */}
                                    {productPrice < 1500 && allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                                        <p>
                                            Za mała wartość. Min. 1500 zł
                                        </p>
                                    }
                                </>
                            }
                            {!isShop &&
                                <>
                                    {(productPrice < 1500 && productPrice > 0 || props.clickedButton > 0 && productPrice < 1500) &&
                                        <p>
                                            Za mała wartość.
                                        </p>
                                    }
                                    {/* {productPrice >= 1500 && productPrice < 4500 && allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                                        <p>
                                            Za mała wartość. Min. 4,5tys. zł
                                        </p>
                                    } */}
                                    {productPrice < 1500 && allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                                        <p>
                                            Za mała wartość. Min. 1500 zł
                                        </p>
                                    }
                                </>
                            }
                        </div>
                    </div>
                    { activeModal &&
                        <ModalMessage closeModal={ () => setActiveModal(false) } 
                                    tipHeader="Sprawdź dane"
                                    // tipText="Sprawdź poprawność wprowadzonych danych.<br />Minimalna wartość koszyka to 4 500,00 zł netto. Nie dotyczy zasad specjalnych." />
                                    tipText="Sprawdź poprawność wprowadzonych danych.<br />Minimalna wartość koszyka to 1 500,00 zł netto. Nie dotyczy zasad specjalnych." />
                    }
        </div>
    )
}

export default LeasingItems;